/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherServer interface.
 */
export function instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherServer(value) {
    if (!('Url' in value) || value['Url'] === undefined)
        return false;
    if (!('HealthCheck' in value) || value['HealthCheck'] === undefined)
        return false;
    if (!('Name' in value) || value['Name'] === undefined)
        return false;
    return true;
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherServerFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherServerFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherServerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Url': json['Url'],
        'HealthCheck': json['HealthCheck'],
        'Name': json['Name'],
    };
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherServerToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherServerToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherServerToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Url': value['Url'],
        'HealthCheck': value['HealthCheck'],
        'Name': value['Name'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherServer.js.map